export enum CounterResetEnum {
  DELETE = 'delete',
  KEEP = 'keep',
}
